//@flow
import React from 'react';

import {makeStyles, TableCell} from '@material-ui/core';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {useProductVariantContext} from '../../../context/productVariant';
import {useProductVariantRequestContext} from '../../../context/productVariantRequest';
import {useProductContext} from '../../../context';

const useStyles = makeStyles(theme => ({
  numberField: {
    width: '120px',
  },
}));

export default function VariantPriceCell() {
  const classes = useStyles();
  const variant = useProductVariantContext();
  const variantRequest = useProductVariantRequestContext();

  const [product] = useProductContext(product => {
    const taxes = product.taxes ?? [];
    const categoryTaxes = product.categoryTaxes ?? [];

    return {
      id: product.id,
      taxes: [...taxes, ...categoryTaxes]
        .map(parseFloat)
        .reduce((a, b) => a + b, 1),
    };
  });

  const handleChange = price => {
    const withTaxPrice = price
      ? parseFloat(Number(price) * product.taxes).toFixed(5)
      : '';
    variantRequest.setPrice(variant.id, price);
    variantRequest.setTaxedPrice(variant.id, withTaxPrice);
  };

  if (!variant || !variantRequest) return null;
  return (
    <TableCell component="th" scope="row">
      <CustomTextField
        name="price"
        className={classes.numberField}
        type="number"
        value={variant.price}
        inputProps={{
          step: '0.01',
        }}
        onChange={e => handleChange(e.target.value)}
      />
    </TableCell>
  );
}
